import { SnackbarService } from './../shared/services/snackbar.service';
import { ComboboxStatus } from './model/combobox-status.model';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatInput, } from '@angular/material';
import { BrokerageFeeService } from './brokerage-fee.service';
import { BrokerageFeePaginationParameters } from './model/brokerage-fee-pagination-parameters.model';
import { BrokerageFeeTable } from './interface/brokerage-fee.table';
import { BrokerageFeeResponseApplyFee } from './interface/brokerage-fee-response-apply-fee';
import { BrokerageFeeTableResponse } from './interface/brokerage-fee-response.table';
import { jsPDF } from "jspdf";
import { AuthService } from '../core/auth/auth.service';
import { AuthUser } from '../core/auth/auth-frame/auth-user.model';
import { Observable, of } from 'rxjs';
import { Sort } from '@angular/material';
import { CONSTANTS } from '@app/shared/constants';
import { FormGroup, FormBuilder, FormControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Spreadsheet } from '@app/shared/export/spreadsheet';
import { differenceInCalendarDays } from 'date-fns';
import { SessionService } from '../core/session/session.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogBrookageComponent } from './dialog-brookage/dialog-brookage.component';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { LanguageService } from '@app/core/language/language.service';
import { TranslateService } from '@ngx-translate/core';
import { ExportHeaders } from './model/ExportHeaders';
import { forEach } from '@angular/router/src/utils/collection';

const namePage = 'cadastro/taxaCorretagem';
@Component({
    selector: 'app-brokerage-fee',
    templateUrl: './brokerage-fee.component.html',
    styleUrls: ['./brokerage-fee.component.css']
})


export class BrokerageFeeComponent implements OnInit {

    private authUser: AuthUser;
    authSubject: Observable<AuthUser>;
    private jwt: string = this.sessionService.retrieveToken();

    BrokerageFeePaginationParameters: BrokerageFeePaginationParameters;
    filterForm: FormGroup;

    dataSource = new MatTableDataSource();
    floatLabelControl = new FormControl('auto');

    minDate: Date = new Date(1970, 1, 1);
    pageIndex: number;

    checkHeaderCliente: boolean = false;
    checkHeaderCorretora: boolean = false;

    hearderToExporPdf = new ExportHeaders();
    hearderToExporExcel = new ExportHeaders();

    closingDate: Date;
    lang = "";
    displayedColumns: string[] = ['carteira', 'operacao', 'contrato_emprestimo_acao', 'corretora', 'modalidade', 'papel', 'quantidade_acoes_boleta', 'qtd_acoes_contrato', 'data_pregao', 'status', 'valor_taxa_cliente', 'percentual_taxa_cliente', 'valor_taxa_corretora', 'percentual_taxa_corretora', 'CheckedBox_Corretora_Cliente'];

    typeStatus: ComboboxStatus[];
    typesModality: any[] = [
        { value: "0", viewValue: "D0" },
        { value: "1", viewValue: "D1" },
        { value: "B", viewValue: "Balcão" }
    ];

    isMobile = false;
    currentPage = 0;
    pageSizeOptions: number[] = [50, 100, 150];
    pageSize: number = this.pageSizeOptions[0];

    constructor(
        public readonly languageService: LanguageService,
        private readonly translateService: TranslateService,
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private snackbarService: SnackbarService,
        private BrokerageFeeService: BrokerageFeeService,
        private sessionService: SessionService,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
    ) {
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe((user: AuthUser) => {
            this.authUser = user;
        });
    }

    ngOnInit() {

        this.showLoading = true;
        this.isMobile = window.innerWidth <= 760;
        this.changeLang();
        this.buildFilterForm();
        this.loadStatusCombobox();
        //this.startGrid();
    }

    @Input() showLoading: Boolean = false;

    @ViewChild('pickerStartDate', {
        read: MatInput
    }) pickerStartDate: MatInput;
    @ViewChild('pickerEndDate', {
        read: MatInput
    }) pickerEndDate: MatInput;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    //Valida check box para envio de escolha de taxa
    vldCheckBox(event, table: BrokerageFeeTable) {
        if (table.checked_cliente && (event.source.name === 'Nao' || event.source.name === 'CheckAllCliente')) {
            table.checked_corretora = false;
        }
        if (table.checked_corretora && (event.source.name === 'Sim' || event.source.name === 'CheckAllCorretora')) {
            table.checked_cliente = false;
        }
    }

    Checkedelement(chekname: string, table: BrokerageFeeTable): boolean {
        if (chekname === 'Sim' && table.status === "1") {
            table.checked_cliente = true;
            return true
        } else
            if (chekname === 'Nao' && table.status === "2") {
                table.checked_corretora = true;
                return true
            }
        return false;
    }

    //Carrega os Status do BackEnd
    loadStatusCombobox(): void {
        const parameters = this.getParameters();
        this.BrokerageFeeService.getStatus(parameters).subscribe(
            (response: HttpResponse<any>) => {
                this.typeStatus = this.BrokerageFeeService.jsonDataToComboboxStatuss(response.body);
                if (response.headers.get('x-jwt') && response.headers.get('x-jwt').toString().trim() != this.jwt.trim()) {
                    this.BrokerageFeeService.setToken(response.headers.get('x-jwt'));
                    this.isWorkingDate();
                }
                this.showLoading = false;
            },
            err => {
                this.showLoading = false;
                console.error(err);
                this.handleError('Não foi possível carregar os status de demandas.');
                this.typeStatus = [];
                if (err.headers.get('x-jwt') && err.headers.get('x-jwt').toString().trim() != this.jwt.trim()) {
                    this.BrokerageFeeService.setToken(err.headers.get('x-jwt'));
                }
            }
        );
    }


    // Limpa o formulario e realiza validações
    buildFilterForm(): void {
        this.filterForm = this.formBuilder.group(
            {
                carteira: [''],
                data_inicio_negociacao: [{ value: '', disabled: false }],
                data_fim_negociacao: [{ value: '', disabled: false }],
                modalidade: [''],
                corretora: [''],
                status: [''],
                papel: ['']
            },
            { validators: [startEndValidator, emptyStartDateValidator, emptyEndDateValidator, stardEndDateMaxRange] }
        );
        if (this.isMobile) {
            this.filterForm.get('data_inicio_negociacao').enable();
            this.filterForm.get('data_fim_negociacao').enable();
        }
    };

    getActiveSortColumn(sort: Sort) {
        if (sort) {
            if (sort.active === 'status') {
                return 'STATUS_NAME';
            } else if (sort.active === 'database') {
                return 'CREATION_DATE_TIME'
            } else if (sort.active === 'unreadCommentNotification') {
                return 'UNREAD_COMMENT_NOTIFICATION';
            }
        } else {
            return 'UNREAD_COMMENT_NOTIFICATION';
        }
    };

    //Determina Ordenação das colunas
    getDirectionSort() {
        if (this.sort) {
            if (this.sort.direction.trim() !== '') {
                return this.sort.direction.toUpperCase().toString();
            } else {
                return this.sort.start.toUpperCase().toString();
            }
        } else {
            return 'DESC'.toString();
        }
    };

    //Realiza repasse de horario limite e valida o horario limite
    isWorkingDate() {
        try {
            let dateTimeNow = new Date();
            this.BrokerageFeeService.getWorkTime(this.getParameters())
                .subscribe(
                    (resp: HttpResponse<any>) => {
                        this.BrokerageFeeService.setToken(resp.headers.get('x-jwt'));
                        let hour = resp.body['horario_limite'];
                        let hoursdigits = hour.toString().split(':');
                        this.closingDate = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth(), dateTimeNow.getDate(), parseInt(hoursdigits[0]), parseInt(hoursdigits[1]), parseInt(hoursdigits[2]));
                        if (dateTimeNow > this.closingDate) {
                            if (this.lang === 'pt-BR') {
                                this.snackBar.open('Horario de operação ate as 20 Horas');
                            } else {
                                this.snackBar.open('The deadline for fee approval is 08:00pm');
                            }
                        }
                    }, (error: HttpErrorResponse) => {
                        this.showLoading = false;
                        this.BrokerageFeeService.setToken(error.headers.get('x-jwt'));
                        console.error(error);
                    }
                )
        }
        catch {

        }

    }

    //Retorna todos os parametros da tela
    getParameters(): BrokerageFeePaginationParameters {

        this.BrokerageFeePaginationParameters = {
            carteira: this.filterForm.value.carteira,
            data_inicio_negociacao: this.filterForm.value.data_inicio_negociacao,
            data_fim_negociacao: this.filterForm.value.data_fim_negociacao,
            modalidade: this.filterForm.value.modalidade,
            corretora: this.filterForm.value.corretora,
            status: this.filterForm.value.status,
            papel: this.filterForm.value.papel,

            gestorName: this.authUser.gestor,
            userName: this.authUser.name,
            pageIndex: this.currentPage,
            pageSize: this.pageSize,
            sortColumn: this.getActiveSortColumn(this.sort),
            sortOrder: this.getDirectionSort(),
            jwt: this.sessionService.retrieveToken(),
        };
        return this.BrokerageFeePaginationParameters;
    };

    //Tratamento de erro
    handleError(message: string): void {
        this.snackbarService.showSnackbar(message, CONSTANTS.GLOBAL.OK.toUpperCase());
    }

    //Atualiza variaveis de paginação
    handlePage(e: any) {
        this.currentPage = e.pageIndex;
        this.pageSize = e.pageSize;
        this.searchBrokerageFee();
    }

    //Aplica o filtro e realiza validação se ocorreu erro no filtro
    applyFilter() {
        this.changeLang();
        let consistente: boolean = true;
        consistente = !(this.filterForm.value.status.length === 1 && this.filterForm.value.status[0] === 3)
        if (!this.filterForm.valid && consistente) {
            if (this.filterForm.hasError('emptyStartDate')) {
                if (this.lang === 'pt-BR') {
                    this.handleError('Preencha a data corretamente.');
                } else {
                    this.handleError('fill the value of date correctly.');
                }
            } else if (this.filterForm.hasError('emptyEndDate')) {
                if (this.lang === 'pt-BR') {
                    this.handleError('Preencha a data corretamente.');
                } else {
                    this.handleError('fill the value of to date correctly.');
                }
            } else if (this.filterForm.hasError('startEndInvalid')) {
                if (this.lang === 'pt-BR') {
                    this.handleError('A data inicial não pode ser maior que a data final.');
                } else {
                    this.handleError('The start date cannot be bigger than end date.');
                }
            } else if (this.filterForm.hasError('MaxRange')) {
                if (this.lang === 'pt-BR') {
                    this.handleError('O range de datas deve ser no máximo de 60 dias.');
                } else {
                    this.handleError('The max value between start date and end date cannot exced 60 days.');
                }
            } else {
                if (this.lang === 'pt-BR') {
                    this.handleError('O filtro possui campos inválidos.');
                } else {
                    this.handleError('The filter form Has Inavalid fields.');
                }
            }
        } else {
            this.searchBrokerageFee(true);
        }
    };

    //Inicializa com a Grid Preenchida contando com D-2
    public startGrid() {
        const parameters = this.getParameters();
        parameters.data_fim_negociacao = new Date();

        var result = new Date();
        result.setDate(result.getDate());
        parameters.data_inicio_negociacao = result;

        this.listBrokerageFeeByParameters(parameters);
    }

    //Realiza validações e atualiza page index
    public searchBrokerageFee(pageIndex?: any): void {
        const parameters = this.getParameters();
        if (pageIndex) {
            parameters.pageIndex = 0;
            if (this.paginator) {
                this.paginator.pageIndex = 0;
            }
        }
        if (!Array.isArray(parameters.modalidade)) {
            parameters.modalidade = [];
        }
        if (!Array.isArray(parameters.status)) {
            parameters.status = [];
        }
        this.listBrokerageFeeByParameters(parameters);
    }

    //Repasse de Satatus
    public replaceStatus(status: number | any, typeStatus: ComboboxStatus[]): String {
        for (let i = 0; i < typeStatus.length; i++) {
            if (status === typeStatus[i].codigo_status_taxa_corretagem) {
                return typeStatus[i].nome_status_taxa_corretagem
            }
        }
    }

    //Chama o Serviço que irá buscad no backend
    public listBrokerageFeeByParameters(brokerageFeePaginationParameters: BrokerageFeePaginationParameters): void {
        if (brokerageFeePaginationParameters) {
            this.showLoading = true;
            this.checkHeaderCliente = false;
            this.checkHeaderCorretora = false;
            this.BrokerageFeeService.getBrokerageFeeList(brokerageFeePaginationParameters).subscribe(
                (brokerageFeeResponse: HttpResponse<any>) => {
                    this.changeLang();
                    //Repassa o novo token
                    this.BrokerageFeeService.setToken(brokerageFeeResponse.headers.get('x-jwt'));
                    if (brokerageFeeResponse.body.content) {
                        this.dataSource = new MatTableDataSource(brokerageFeeResponse.body.content as BrokerageFeeTableResponse[]);
                        //Formata data para dd/mm/aaaa
                        this.dataSource.data.forEach(
                            resultMap => {

                                resultMap['data_pregao'] = resultMap['data_pregao'].toLocaleString(this.lang).substr(0, 10);
                                resultMap['status_descricao'] = this.replaceStatus(resultMap['status'], this.typeStatus);
                                resultMap['valor_taxa_cliente'] = resultMap['valor_taxa_cliente'] ? resultMap['valor_taxa_cliente'].toLocaleString(this.lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '';
                                resultMap['percentual_taxa_cliente'] = resultMap['percentual_taxa_cliente'] ? resultMap['percentual_taxa_cliente'].toLocaleString(this.lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '';
                                resultMap['valor_taxa_corretora'] = resultMap['valor_taxa_corretora'] ? resultMap['valor_taxa_corretora'].toLocaleString(this.lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '';
                                resultMap['percentual_taxa_corretora'] = resultMap['percentual_taxa_corretora'] ? resultMap['percentual_taxa_corretora'].toLocaleString(this.lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '';
                                resultMap['checked_cliente'] = resultMap['status'] == '2' ? true : false;
                                resultMap['checked_corretora'] = resultMap['status'] == '1' ? true : false;
                            }
                        )

                        //Atualiza paginação
                        if (this.paginator) {
                            this.paginator.length = brokerageFeeResponse.body['totalElements'] as number;
                        }
                        this.showLoading = false;
                    } else {
                        this.dataSource = new MatTableDataSource();
                        this.showLoading = false;
                    }
                },
                (error: HttpErrorResponse) => {
                    this.showLoading = false;
                    this.BrokerageFeeService.setToken(error.headers.get('x-jwt'));
                    console.error(error);
                }
            );
        }
    }

    //Abre o Dialog para menssagem em tela
    public OpenDialog(title: string, text: string | string[]) {
        const conf = new MatDialogConfig();
        conf.data =
        {
            title: title,
            text: text
        };
        this.dialog.open(DialogBrookageComponent, conf);
        this.listBrokerageFeeByParameters(this.getParameters());
    }

    //Aplica as taxas selecionadas
    applyFees() {
        const parameters = this.getParameters();
        let dateTimeNow = new Date();
        if (dateTimeNow > this.closingDate) {
            this.snackBar.open('Horario de operação ate as 20 Horas');
        } else {
            this.showLoading = true;
            let arrErro = [];
            let result: [{
                'codLiquidacao': any;
                'acao': any;

            }];
            result = [{
                'codLiquidacao': '',
                'acao': ''
            }];
            result.pop();
            let arrToFind = this.dataSource.data.filter((x: BrokerageFeeTable) => x.checked_corretora === true || x.checked_cliente === true);

            for (let index = 0; index < arrToFind.length; index++) {
                if (arrToFind[index]['status'] === 3) {
                    result.push(
                        {
                            'codLiquidacao': arrToFind[index]['codigo_liquidacao_corretagem'],
                            'acao': arrToFind[index]['checked_corretora'] === true ? 'aprovar' : 'reprovar'
                        });
                }
            }
            console.log(result)
            if (result.length <= 0) {
                this.OpenDialog('Não há taxas a serem aprovadas', '');
            }
            this.BrokerageFeeService.updateBrokerageFeeList(result, parameters)
                .subscribe(resp => {
                    this.BrokerageFeeService.setToken(resp.headers.get('x-jwt'));
                    arrErro = resp.body.filter((responseApplyFee: BrokerageFeeResponseApplyFee) => responseApplyFee['result'] === false);
                    this.showLoading = false;
                    if (arrErro.length > 0) {
                        this.OpenDialog('Erro nos seguintes contratos:', arrErro);
                    } else {
                        this.OpenDialog('Sucesso', 'Todas as taxas selecionadas foram validadas !');
                    }
                }, (error: HttpErrorResponse) => {
                    this.showLoading = false;
                    this.BrokerageFeeService.setToken(error.headers.get('x-jwt'));
                    console.error(error);
                });
        }
    }

    //Limpa o Filtro
    public clearFilter(): void {
        this.pageSize = this.pageSizeOptions[0];
        this.filterForm.reset();
        this.buildFilterForm();
    }

    //Export PDF
    public downloadPDF() {
        this.changeLang();

        //  resultPDF2.this.hearderToExporPdf.Carteira  = '';
        let resultPDF = [];
        let headerExportPDF = [];
        if (this.lang === 'pt-BR') {
            resultPDF = [{
                '%Cliente': '',
                '%Corretora': '',
                'Carteira': '',
                'Contrato': '',
                ' Corretora ': '',
                'DataOperacao': '',
                'Status': '',
                'Modalidade': '',
                'Operacao': '',
                'Papel': '',
                'Quantidade': '',
                'Qtd Ctr': '',
                'TaxaCliente': '',
                'TaxaCorretora': ''
            }];


        } else {
            resultPDF = [{
                'Client%': '',
                'Broker%': '',
                'Portifolio': '',
                'Contract': '',
                ' Broker ': '',
                'Oper Date': '',
                'Status': '',
                'Modality': '',
                'Transaction': '',
                'Paper': '',
                'Quantity': '',
                'Qty Cont.': '',
                'ClientValue': '',
                'BrokerValue': ''
            }];
        }
        headerExportPDF = [
            this.hearderToExporPdf.Carteira,
            this.hearderToExporPdf.Contrato,
            this.hearderToExporPdf.Corretora,
            this.hearderToExporPdf.DataOperacao,
            this.hearderToExporPdf.Status,
            this.hearderToExporPdf.Modalidade,
            this.hearderToExporPdf.Opercao,
            this.hearderToExporPdf.Papel,
            this.hearderToExporPdf.Quantidade,
            this.hearderToExporPdf.Quantidade_ON6,
            this.hearderToExporPdf.TaxaCliente,
            this.hearderToExporPdf.TaxaCorretora,
            this.hearderToExporPdf.perCliente,
            this.hearderToExporPdf.perCorretora
        ];

        let rowLimit = 500;
        let pagination = this.getParameters();
        let img = new Image()
        let carteira, corretora, opercao, papel, modalidade, dtOperacao, contrato, percCliente, percCorretora, quantidade, quantidade_on6, vlrCliente, vlrCorretora: string;
        let doc = new jsPDF('landscape', 'px', 'a3', true);

        this.showLoading = true;
        img.src = './assets/img/logo-1x.jpg'
        pagination.pageIndex = 0;
        pagination.pageSize = rowLimit;
        pagination.status = pagination.status || [];
        resultPDF.pop();
        this.BrokerageFeeService.getBrokerageFeeExport(pagination)
            .subscribe(
                // (response: Array<BrokerageFeeTable>) => {
                (response: HttpResponse<any>) => {
                    this.BrokerageFeeService.setToken(response.headers.get('x-jwt'));
                    let arrBrook: Array<BrokerageFeeTableResponse> = response.body;
                    arrBrook.forEach(
                        resultMap => {
                            if (this.lang === 'pt-BR') {
                                resultPDF.push(
                                    {
                                        'Carteira': resultMap['carteira'] === null ? carteira = '-' : carteira = resultMap['carteira'].toString().trim(),
                                        ' Corretora ': resultMap['corretora'] === null ? corretora = '-' : corretora = resultMap['corretora'].toString().trim(),
                                        'Operacao': resultMap['operacao'] === null ? opercao = '-' : opercao = resultMap['operacao'].toString().trim(),
                                        'Papel': resultMap['papel'] === null ? papel = '' : papel = resultMap['papel'].toString().trim(),
                                        'Modalidade': resultMap['modalidade'] === null ? modalidade = '-' : modalidade = resultMap['modalidade'].toString().trim(),
                                        'DataOperacao': resultMap['data_pregao'] === null ? dtOperacao = '-' : dtOperacao = resultMap['data_pregao'].substr(0, 10),
                                        'Contrato': resultMap['contrato_emprestimo_acao'] === null ? contrato = '-' : contrato = resultMap['contrato_emprestimo_acao'].toString().trim(),
                                        '%Cliente': resultMap['percentual_taxa_cliente'] === null ? percCliente = '-' : percCliente = Number(resultMap['percentual_taxa_cliente']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                                        '%Corretora': resultMap['percentual_taxa_corretora'] === null ? percCorretora = '-' : percCorretora = Number(resultMap['percentual_taxa_corretora']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                                        'Quantidade': resultMap['quantidade_acoes_boleta'] === null ? quantidade = '-' : quantidade = resultMap['quantidade_acoes_boleta'].toString().trim(),
                                        'Qtd Ctr': resultMap['qtd_acoes_contrato'] === null ? quantidade_on6 = '-' : quantidade_on6 = resultMap['qtd_acoes_contrato'].toString().trim(),
                                        'TaxaCliente': resultMap['valor_taxa_cliente'] === null ? vlrCliente = '-' : vlrCliente = Number(resultMap['valor_taxa_cliente']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                                        'TaxaCorretora': resultMap['valor_taxa_corretora'] === null ? vlrCorretora = '-' : vlrCorretora = Number(resultMap['valor_taxa_corretora']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                                        'Status': resultMap['status'] === null ? status = '-' : status = this.BrokerageFeeService.ChangeLang(Number(resultMap['status'])),
                                    }
                                );
                            } else {
                                resultPDF.push(
                                    {
                                        'Portifolio': resultMap['carteira'] === null ? carteira = '-' : carteira = resultMap['carteira'].toString().trim(),
                                        ' Broker ': resultMap['corretora'] === null ? corretora = '-' : corretora = resultMap['corretora'].toString().trim(),
                                        'Transaction': resultMap['operacao'] === null ? opercao = '-' : opercao = resultMap['operacao'].toString().trim(),
                                        'Paper': resultMap['papel'] === null ? papel = '' : papel = resultMap['papel'].toString().trim(),
                                        'Modality': resultMap['modalidade'] === null ? modalidade = '-' : modalidade = resultMap['modalidade'].toString().trim(),
                                        'Oper Date': resultMap['data_pregao'] === null ? dtOperacao = '-' : dtOperacao = resultMap['data_pregao'].substr(0, 10),
                                        'Contract': resultMap['contrato_emprestimo_acao'] === null ? contrato = '-' : contrato = resultMap['contrato_emprestimo_acao'].toString().trim(),
                                        'Client%': resultMap['percentual_taxa_cliente'] === null ? percCliente = '-' : percCliente = Number(resultMap['percentual_taxa_cliente']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                                        'Broker%': resultMap['percentual_taxa_corretora'] === null ? percCorretora = '-' : percCorretora = Number(resultMap['percentual_taxa_corretora']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                                        'Quantity': resultMap['quantidade_acoes_boleta'] === null ? quantidade = '-' : quantidade = resultMap['quantidade_acoes_boleta'].toString().trim(),
                                        'Qty Cont.': resultMap['qtd_acoes_contrato'] === null ? quantidade_on6 = '-' : quantidade_on6 = resultMap['qtd_acoes_contrato'].toString().trim(),
                                        'ClientValue': resultMap['valor_taxa_cliente'] === null ? vlrCliente = '-' : vlrCliente = Number(resultMap['valor_taxa_cliente']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                                        'BrokerValue': resultMap['valor_taxa_corretora'] === null ? vlrCorretora = '-' : vlrCorretora = Number(resultMap['valor_taxa_corretora']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                                        'Status': resultMap['status'] === null ? status = '-' : status = this.BrokerageFeeService.ChangeLang(Number(resultMap['status'])),
                                    }
                                );
                            }
                        }
                    );
                    doc.setLanguage('pt-BR');
                    doc.addImage('./assets/img/logo-3x.jpg', 'jpg', 850, 10, 20, 20, 'Logo', 'NONE', 0);
                    doc.table(
                        8,
                        40,
                        resultPDF,
                        this.createHeaders(headerExportPDF),
                        {
                            fontSize: 11.5,
                            printHeaders: true,
                            autoSize: true,
                            headerBackgroundColor: '#EC7406'
                        },
                    );
                    doc.save('TaxadeCorretagem.pdf');
                    this.showLoading = false;
                },
                error => {
                    this.showLoading = false;
                    console.error(error);
                }
            );
    }

    //Criacao de Header para export do PDF.
    public createHeaders(keys) {
        return keys.map(key => ({
            'name': key,
            'prompt': key,
            'width': 40,
            'align': 'center',
            'padding': 0
        }));
    }

    //Export Excel
    public downloadExcel(): void {
        this.changeLang();
        this.showLoading = true;
        const rowLimit = 15000;
        const parameters = this.getParameters();
        parameters.pageIndex = 0;
        parameters.pageSize = rowLimit;
        parameters.status = parameters.status || [];
        this.BrokerageFeeService.getBrokerageFeeExport(parameters)
            .subscribe(
                (response: HttpResponse<any>) => {

                    //Set novo token
                    this.BrokerageFeeService.setToken(response.headers.get('x-jwt'));

                    let arrBrook: Array<BrokerageFeeTableResponse> = response.body;
                    const tableToExport = this.convertToSpreadsheet(arrBrook);
                    if (tableToExport.length >= rowLimit) {
                        this.showLimitToExportMessage(rowLimit);
                    }
                    const spreadsheetGenerator = new Spreadsheet<BrokerageFeeTableResponse>('Taxa de Corretagem', tableToExport);
                    spreadsheetGenerator.generateSpreadsheet();
                    this.showLoading = false;
                },
                error => {
                    this.showLoading = false;
                    console.error(error);
                }
            );
    }

    //Coversao de campos para export
    private convertToSpreadsheet(table: Array<BrokerageFeeTableResponse>): Array<any> {
        if (this.lang === 'pt-BR') {
            return table.map((brokerageFee: BrokerageFeeTableResponse) => ({
                'Carteira': brokerageFee.carteira,
                'Código da Operação': brokerageFee.operacao,
                'Número do Contrato': brokerageFee.contrato_emprestimo_acao,
                'Código da Corretora': brokerageFee.corretora,
                'Modalidade da Boleta': brokerageFee.modalidade,
                'Papel': brokerageFee.papel,
                'Quantidade de Ações': brokerageFee.quantidade_acoes_boleta,
                'Quantidade de Ações ON6': brokerageFee.qtd_acoes_contrato,
                'Data Operação': brokerageFee.data_pregao,
                'Status': brokerageFee.status_descricao === null ? brokerageFee.status_descricao = '-' : brokerageFee.status_descricao = brokerageFee.status_descricao.toString().trim(),
                'Taxa Enviada pelo Cliente': brokerageFee.valor_taxa_cliente,
                'Percentual Enviado pelo Cliente': brokerageFee.percentual_taxa_cliente,
                'Taxa Enviada pela Corretora': brokerageFee.valor_taxa_corretora,
                'Percentual Enviado pela Corretora': brokerageFee.percentual_taxa_corretora,

            }));
        } else {
            return table.map((brokerageFee: BrokerageFeeTableResponse) => ({
                'Portifolio': brokerageFee.carteira,
                'Transaction': brokerageFee.operacao,
                'Contract': brokerageFee.contrato_emprestimo_acao,
                'Broker': brokerageFee.corretora,
                'Modality': brokerageFee.modalidade,
                'Paper': brokerageFee.papel,
                'Quantity': brokerageFee.quantidade_acoes_boleta,
                'Quantit Cont': brokerageFee.qtd_acoes_contrato,
                'Transaction Date': brokerageFee.data_pregao,
                'Status': brokerageFee.status_descricao === null ? brokerageFee.status_descricao = '-' : brokerageFee.status_descricao = this.BrokerageFeeService.ChangeLang(brokerageFee.status),
                'Client fee Value': brokerageFee.valor_taxa_cliente,
                'Client %': brokerageFee.percentual_taxa_cliente,
                'Broker fee Value': brokerageFee.valor_taxa_corretora,
                'Broker %': brokerageFee.percentual_taxa_corretora,

            }));
        }
    }

    private showLimitToExportMessage(limit: number): void {
        this.handleError(this.messageExportLimit(limit));
    }

    public messageExportLimit(limit: number) {
        return `O limite para a exportação é de ${limit} registros,`
            + ` apenas os primeiros ${limit} serão exibidos, você pode refazer a busca para`
            + ' exportar todas as demandas que necessita visualizar.';
    }
    //Desabilita CheckBox
    public disableCheckBox(table: BrokerageFeeTableResponse): boolean {
        if (table.codigo_liquidacao_corretagem && table.status.toString().trim() === '3') {
            return false;
        } else {
            return true;
        }
    };

    public changeLang() {
        this.lang = localStorage.getItem('lang') === 'br' ? 'pt-BR' : 'en-US';
        if (this.lang === 'pt-BR') {

            //pdf headers
            this.hearderToExporPdf.Carteira = 'Carteira';
            this.hearderToExporPdf.Contrato = 'Contrato';
            this.hearderToExporPdf.Corretora = ' Corretora ';
            this.hearderToExporPdf.DataOperacao = 'DataOperacao';
            this.hearderToExporPdf.Status = 'Status';
            this.hearderToExporPdf.Modalidade = 'Modalidade';
            this.hearderToExporPdf.Opercao = 'Operacao';
            this.hearderToExporPdf.Papel = 'Papel';
            this.hearderToExporPdf.Quantidade = 'Quantidade';
            this.hearderToExporPdf.Quantidade_ON6 = 'Qtd Ctr';
            this.hearderToExporPdf.TaxaCliente = 'TaxaCliente';
            this.hearderToExporPdf.TaxaCorretora = 'TaxaCorretora';
            this.hearderToExporPdf.perCliente = '%Cliente';
            this.hearderToExporPdf.perCorretora = '%Corretora';

            //excel headers
            this.hearderToExporExcel.Carteira = 'Carteira';
            this.hearderToExporExcel.Opercao = 'Código da Operação';
            this.hearderToExporExcel.Contrato = 'Número do Contrato';
            this.hearderToExporExcel.Corretora = 'Código da Corretora';
            this.hearderToExporExcel.Modalidade = 'Modalidade da Boleta';
            this.hearderToExporExcel.Papel = 'Papel';
            this.hearderToExporExcel.Quantidade = 'Quantidade de Ações';
            this.hearderToExporExcel.Quantidade_ON6 = 'Quantidade de Ações Contrato';
            this.hearderToExporExcel.DataOperacao = 'Data Operação';
            this.hearderToExporExcel.Status = 'Status';
            this.hearderToExporExcel.TaxaCliente = 'Taxa Enviada pelo Cliente';
            this.hearderToExporExcel.perCliente = 'Percentual Enviado pelo Cliente';
            this.hearderToExporExcel.TaxaCorretora = 'Taxa Enviada pela Corretora';
            this.hearderToExporExcel.perCorretora = 'Percentual Enviado pela Corretora';

        } else {
            this.hearderToExporPdf.Carteira = 'Portifolio';
            this.hearderToExporPdf.Contrato = 'Contract';
            this.hearderToExporPdf.Corretora = ' Broker ';
            this.hearderToExporPdf.DataOperacao = 'Oper Date';
            this.hearderToExporPdf.Status = 'Status';
            this.hearderToExporPdf.Modalidade = 'Modality';
            this.hearderToExporPdf.Opercao = 'Transaction';
            this.hearderToExporPdf.Papel = 'Paper';
            this.hearderToExporPdf.Quantidade = 'Quantity';
            this.hearderToExporPdf.Quantidade_ON6 = 'Qty Cont.';
            this.hearderToExporPdf.TaxaCliente = 'ClientValue';
            this.hearderToExporPdf.TaxaCorretora = 'BrokerValue';
            this.hearderToExporPdf.perCliente = 'Client%';
            this.hearderToExporPdf.perCorretora = 'Broker%';

            this.hearderToExporExcel.Carteira = 'Portifolio';
            this.hearderToExporExcel.Contrato = 'Contract';
            this.hearderToExporExcel.Corretora = ' Broker ';
            this.hearderToExporExcel.DataOperacao = 'Oper Date';
            this.hearderToExporExcel.Status = 'Status';
            this.hearderToExporExcel.Modalidade = 'Modality';
            this.hearderToExporExcel.Opercao = 'Transaction';
            this.hearderToExporExcel.Papel = 'Paper';
            this.hearderToExporExcel.Quantidade = 'Quantity';
            this.hearderToExporExcel.Quantidade_ON6 = 'Qty Cont.';
            this.hearderToExporExcel.TaxaCliente = 'ClientValue';
            this.hearderToExporExcel.TaxaCorretora = 'BrokerValue';
            this.hearderToExporExcel.perCliente = 'Client%';
            this.hearderToExporExcel.perCorretora = 'Broker%';


        }
    };

    // Marca todos o check box
    public checkAll(event) {
        this.dataSource.data
            .forEach(element => {
                if (event.source.name === 'CheckAllCliente' && element['codigo_liquidacao_corretagem'] !== null && element['status'].toString().trim() === '3') {
                    element['checked_cliente'] = event.source.checked;
                    if (element['checked_cliente'] === true) {
                        element['checked_corretora'] = !event.source.checked;
                    }
                }
                else if (event.source.name === 'CheckAllCorretora' && element['codigo_liquidacao_corretagem'] !== null && element['status'].toString().trim() === '3') {
                    element['checked_corretora'] = event.source.checked;
                    if (element['checked_cliente'] === true) {
                        element['checked_cliente'] = !event.source.checked;
                    }
                }

            });

        if (event.source.name === 'CheckAllCliente' && this.checkHeaderCorretora) {
            this.checkHeaderCorretora = false;
        }
        if (event.source.name === 'CheckAllCorretora' && this.checkHeaderCliente) {
            this.checkHeaderCliente = false;
        }
    };

}

//Valida se a data Final é maior do que a data inicial
export const startEndValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const startDate = control.get('data_inicio_negociacao');
    const endDate = control.get('data_fim_negociacao');
    return startDate && startDate.value && endDate && endDate.value && startDate.value > endDate.value ? { 'startEndInvalid': true } : null;
};

//Valida se as data inicial esta vazia
export const emptyStartDateValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const startDate = control.get('data_inicio_negociacao');
    return (!startDate || !startDate.value) ? { 'emptyStartDate': true } : null;
};

//Valida se as data final esta vazia
export const emptyEndDateValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const endDate = control.get('data_fim_negociacao');
    return (!endDate || !endDate.value) ? { 'emptyEndDate': true } : null;
};

//Valida se a data inicial nao ultrapassa 60 dias da data final
export const stardEndDateMaxRange: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const result = differenceInCalendarDays(
        new Date(control.get('data_fim_negociacao').value),
        new Date(control.get('data_inicio_negociacao').value)
    );

    return (result > 60 && control.get('status').value != 3) ? { 'MaxRange': true } : null;
};


